export function getApiHost() {
  if (Config.apiEndpoint) {
    return Config.apiEndpoint;
  }

  if (Config.nodeEnv === "production") {
    return "https://api.classdojo.com";
  }

  return "http://api.classdojo.test:8001";
}

export function getTeachHost() {
  if (Config.apiEndpoint) {
    return Config.apiEndpoint;
  }

  if (Config.nodeEnv === "production") {
    return "https://teach.classdojo.com";
  }

  return "http://teach.classdojo.test:8001";
}
